const esToEn: Record<string, string> = {
  'hola': 'hello',
  'hola!': 'hello!',
  'hola,': 'hello,',
  'buenos días': 'good morning',
  'buenos días,': 'good morning,',
  'buenas tardes': 'good afternoon',
  'buenas tardes,': 'good afternoon,',
  'buenas noches': 'good night',
  'buenas noches,': 'good night,',
  'gracias': 'thank you',
  'gracias!': 'thank you!',
  'muchas gracias': 'thank you very much',
  'muchas gracias!': 'thank you very much!',
  'de nada': "you're welcome",
  'de nada!': "you're welcome!",
  'por favor': 'please',
  'disculpa': 'sorry',
  'disculpá': 'sorry',
  'perdón': 'sorry',
  'perdon': 'sorry',
  'sí': 'yes',
  'si': 'yes',
  'no': 'no',
  'claro': 'of course',
  'claro!': 'of course!',
  'perfecto': 'perfect',
  'perfecto!': 'perfect!',
  'genial': 'great',
  'genial!': 'great!',
  'excelente': 'excellent',
  'excelente!': 'excellent!',
  'ok': 'ok',
  'ok!': 'ok!',
  'dale': 'ok',
  'dale!': 'ok!',
  'entiendo': 'I understand',
  'no entiendo': "I don't understand",
  'no entiendo.': "I don't understand.",
  '¿cómo estás?': 'how are you?',
  'como estas?': 'how are you?',
  '¿cómo estás': 'how are you',
  'bien, gracias': 'fine, thank you',
  'muy bien': 'very well',
  'todo bien': 'all good',
  'todo bien!': 'all good!',
  '¿en qué puedo ayudarte?': 'how can I help you?',
  'en que puedo ayudarte?': 'how can I help you?',
  '¿en qué puedo ayudarte': 'how can I help you',
  '¿cómo te puedo ayudar?': 'how can I help you?',
  'como te puedo ayudar?': 'how can I help you?',
  'tengo un problema': 'I have a problem',
  'tengo un problema.': 'I have a problem.',
  'necesito ayuda': 'I need help',
  'necesito ayuda.': 'I need help.',
  'necesito ayuda con': 'I need help with',
  '¿podrías explicarme?': 'could you explain?',
  'podrias explicarme?': 'could you explain?',
  '¿podés explicarme?': 'could you explain?',
  'podes explicarme?': 'could you explain?',
  'ya lo reviso': "I'll check it",
  'ya lo reviso.': "I'll check it.",
  'déjame revisar': 'let me check',
  'dejame revisar': 'let me check',
  'déjame ver': 'let me see',
  'dejame ver': 'let me see',
  'está resuelto': "it's resolved",
  'esta resuelto': "it's resolved",
  'está resuelto.': "it's resolved.",
  'ya está resuelto': "it's already resolved",
  'ya esta resuelto': "it's already resolved",
  'resuelto': 'resolved',
  'solucionado': 'solved',
  '¿algo más?': 'anything else?',
  'algo mas?': 'anything else?',
  '¿necesitás algo más?': 'do you need anything else?',
  'necesitas algo mas?': 'do you need anything else?',
  'espera un momento': 'wait a moment',
  'espera un momento.': 'wait a moment.',
  'esperá un momento': 'wait a moment',
  'un momento': 'one moment',
  'un momento,': 'one moment,',
  'hasta luego': 'see you later',
  'hasta luego!': 'see you later!',
  'nos vemos': 'see you',
  'chau': 'bye',
  'chau!': 'bye!',
  'adiós': 'goodbye',
  'adios': 'goodbye',
  'configuración': 'configuration',
  'configuracion': 'configuration',
  'almacenamiento': 'storage',
  'frecuencia': 'frequency',
  'frecuencias': 'frequencies',
  'plan': 'plan',
  'planes': 'plans',
  'evento': 'event',
  'eventos': 'events',
  'transmisión': 'broadcast',
  'transmision': 'broadcast',
  'streaming': 'streaming',
  'música': 'music',
  'musica': 'music',
  'programación': 'schedule',
  'programacion': 'schedule',
  'usuarios': 'users',
  'usuario': 'user',
  'reporte': 'report',
  'reportes': 'reports',
  'factura': 'invoice',
  'facturas': 'invoices',
  'facturación': 'billing',
  'facturacion': 'billing',
  'pago': 'payment',
  'pagos': 'payments',
  'soporte': 'support',
  'chat': 'chat',
  'mensaje': 'message',
  'mensajes': 'messages',
  'cabina': 'cabin',
  'oyentes': 'listeners',
  'oyente': 'listener',
  'radio': 'radio',
  'radios': 'radios',
  'stream': 'stream',
  'conexión': 'connection',
  'conexion': 'connection',
  'error': 'error',
  'caído': 'down',
  'caido': 'down',
  'activo': 'active',
  'inactivo': 'inactive',
  'actualizar': 'update',
  'actualización': 'update',
  'actualizacion': 'update',
  'crear': 'create',
  'editar': 'edit',
  'eliminar': 'delete',
  'buscar': 'search',
  'enviar': 'send',
  'recibir': 'receive',
  'verificar': 'verify',
  'verificación': 'verification',
  'verificacion': 'verification',
  'aprobar': 'approve',
  'rechazar': 'reject',
  'suspender': 'suspend',
  'reactivar': 'reactivate',
  'contraseña': 'password',
  'contrasena': 'password',
  'correo': 'email',
  'email': 'email',
  'teléfono': 'phone',
  'telefono': 'phone',
  'dirección': 'address',
  'direccion': 'address',
  'nombre': 'name',
  'foto': 'photo',
  'fotos': 'photos',
  'video': 'video',
  'videos': 'videos',
  'archivo': 'file',
  'archivos': 'files',
  'link': 'link',
  'enlace': 'link',
  'en vivo': 'live',
  'en vivo.': 'live.',
  'directo': 'live',
  'grabado': 'recorded',
  'horario': 'schedule',
  'horarios': 'schedules',
  'día': 'day',
  'dia': 'day',
  'semana': 'week',
  'mes': 'month',
  'año': 'year',
  'ano': 'year',
  'hora': 'hour',
  'minuto': 'minute',
  'segundo': 'second',
  'hoy': 'today',
  'mañana': 'tomorrow',
  'manana': 'tomorrow',
  'ayer': 'yesterday',
  'ahora': 'now',
  'luego': 'later',
  'después': 'after',
  'despues': 'after',
  'antes': 'before',
  'durante': 'during',
  'siempre': 'always',
  'nunca': 'never',
  'a veces': 'sometimes',
  'también': 'also',
  'tambien': 'also',
  'tampoco': 'neither',
  'pero': 'but',
  'porque': 'because',
  'por qué': 'why',
  'por que': 'why',
  '¿por qué?': 'why?',
  'cuándo': 'when',
  'cuando': 'when',
  '¿cuándo?': 'when?',
  'dónde': 'where',
  'donde': 'where',
  '¿dónde?': 'where?',
  'cómo': 'how',
  'como': 'how',
  '¿cómo?': 'how?',
  'quién': 'who',
  'quien': 'who',
  '¿quién?': 'who?',
  'cuál': 'which',
  'cual': 'which',
  'cuánto': 'how much',
  'cuanto': 'how much',
  'cuántos': 'how many',
  'cuantos': 'how many',
  'mucho': 'much',
  'poco': 'little',
  'más': 'more',
  'mas': 'more',
  'menos': 'less',
  'grande': 'big',
  'pequeño': 'small',
  'pequeno': 'small',
  'nuevo': 'new',
  'viejo': 'old',
  'rápido': 'fast',
  'rapido': 'fast',
  'lento': 'slow',
  'fácil': 'easy',
  'facil': 'easy',
  'difícil': 'difficult',
  'dificil': 'difficult',
  'bueno': 'good',
  'malo': 'bad',
  'mejor': 'better',
  'peor': 'worse',
  'primero': 'first',
  'segundo': 'second',
  'tercero': 'third',
  'último': 'last',
  'ultimo': 'last',
  'lista': 'list',
  'lista.': 'list.',
  'listo': 'ready',
  'listo.': 'ready.',
  'listo!': 'ready!',
  'ya está': "it's done",
  'ya esta': "it's done",
  'ya está.': "it's done.",
  'ya esta.': "it's done.",
  'funciona': 'it works',
  'funciona.': 'it works.',
  'no funciona': "it doesn't work",
  'no funciona.': "it doesn't work.",
  'no funciona,': "it doesn't work,",
  'no puedo': "I can't",
  'puedo': 'I can',
  'podés': 'you can',
  'podes': 'you can',
  'podría': 'could',
  'podria': 'could',
  'debería': 'should',
  'deberia': 'should',
  'quiero': 'I want',
  'querés': 'you want',
  'queres': 'you want',
  'necesito': 'I need',
  'necesitás': 'you need',
  'necesitas': 'you need',
  'tengo': 'I have',
  'tenés': 'you have',
  'tenes': 'you have',
  'hay': 'there is',
  'había': 'there was',
  'habia': 'there was',
  'voy a': "I'm going to",
  'vas a': 'you are going to',
  'vamos a': 'we are going to',
  'estoy': 'I am',
  'estás': 'you are',
  'estas': 'you are',
  'está': 'it is',
  'esta': 'it is',
  'estamos': 'we are',
  'están': 'they are',
  'estan': 'they are',
  'ser': 'to be',
  'estar': 'to be',
  'hacer': 'to do',
  'tener': 'to have',
  'ir': 'to go',
  'venir': 'to come',
  'ver': 'to see',
  'saber': 'to know',
  'decir': 'to say',
  'hablar': 'to speak',
  'escribir': 'to write',
  'leer': 'to read',
  'escuchar': 'to listen',
  'probar': 'to try',
  'revisar': 'to check',
  'revisé': 'I checked',
  'revise': 'I checked',
  'revisaste': 'you checked',
  'encontré': 'I found',
  'encontre': 'I found',
  'encontré el problema': 'I found the problem',
  'encontre el problema': 'I found the problem',
  'arreglé': 'I fixed',
  'arregle': 'I fixed',
  'corregí': 'I corrected',
  'corregi': 'I corrected',
  'cambié': 'I changed',
  'cambie': 'I changed',
  'agregué': 'I added',
  'agregue': 'I added',
  'saqué': 'I removed',
  'saque': 'I removed',
  'subí': 'I uploaded',
  'subi': 'I uploaded',
  'bajé': 'I downloaded',
  'baje': 'I downloaded',
  'la': 'the',
  'el': 'the',
  'los': 'the',
  'las': 'the',
  'un': 'a',
  'una': 'a',
  'unos': 'some',
  'unas': 'some',
  'mi': 'my',
  'tu': 'your',
  'su': 'their',
  'nuestro': 'our',
  'con': 'with',
  'sin': 'without',
  'para': 'for',
  'por': 'by',
  'sobre': 'about',
  'entre': 'between',
  'hasta': 'until',
  'desde': 'from',
  'hacia': 'towards',
  'todo': 'all',
  'toda': 'all',
  'todos': 'all',
  'todas': 'all',
  'nada': 'nothing',
  'algo': 'something',
  'alguien': 'someone',
  'nadie': 'no one',
  'cada': 'each',
  'otro': 'other',
  'otra': 'other',
  'mismo': 'same',
  'misma': 'same',
  'este': 'this',
  'esta': 'this',
  'ese': 'that',
  'esa': 'that',
  'aquel': 'that',
  'moderación': 'moderation',
  'moderacion': 'moderation',
  'filtro': 'filter',
  'filtros': 'filters',
  'bloqueo': 'block',
  'baneo': 'ban',
  'baneado': 'banned',
  'silenciado': 'silenced',
  'comunidad': 'community',
  'publicación': 'post',
  'publicacion': 'post',
  'publicaciones': 'posts',
  'comentario': 'comment',
  'comentarios': 'comments',
  'seguidor': 'follower',
  'seguidores': 'followers',
  'notificación': 'notification',
  'notificacion': 'notification',
  'notificaciones': 'notifications',
  'alerta': 'alert',
  'alertas': 'alerts',
  'dashboard': 'dashboard',
  'panel': 'panel',
  'ajustes': 'settings',
  'configuraciones': 'settings',
  'administrador': 'admin',
  'super admin': 'super admin',
  'locutor': 'host',
  'locutores': 'hosts',
  'staff': 'staff',
  'equipo': 'team',
  'oyente': 'listener',
  'oyentes': 'listeners',
  'invitado': 'guest',
  'invitados': 'guests',
  'partner': 'partner',
  'partners': 'partners',
  'sponsor': 'sponsor',
  'sponsors': 'sponsors',
  'publicidad': 'advertising',
  'anuncio': 'ad',
  'anuncios': 'ads',
  'campaña': 'campaign',
  'campana': 'campaign',
  'marketing': 'marketing',
  'promoción': 'promotion',
  'promocion': 'promotion',
  'descuento': 'discount',
  'precio': 'price',
  'precios': 'prices',
  'gratis': 'free',
  'gratuito': 'free',
  'premium': 'premium',
  'pro': 'pro',
  'business': 'business',
  'starter': 'starter',
  'básico': 'basic',
  'basico': 'basic',
  'ilimitado': 'unlimited',
  'limitado': 'limited',
  'GB': 'GB',
  'MB': 'MB',
  'límite': 'limit',
  'limite': 'limit',
  'alcanzado': 'reached',
  'excedido': 'exceeded',
  'disponible': 'available',
  'ocupado': 'used',
  'libre': 'free',
  'total': 'total',
  'parcial': 'partial',
  'completo': 'complete',
  'incompleto': 'incomplete',
  'pendiente': 'pending',
  'activa': 'active',
  'activo': 'active',
  'enabled': 'enabled',
  'disabled': 'disabled',
  'habilitado': 'enabled',
  'deshabilitado': 'disabled',
  'activado': 'enabled',
  'desactivado': 'disabled',
};

function buildEnToEs(): Record<string, string> {
  const enToEs: Record<string, string> = {};
  for (const [es, en] of Object.entries(esToEn)) {
    if (!enToEs[en]) {
      enToEs[en] = es;
    }
  }
  return enToEs;
}

const enToEs = buildEnToEs();

function translateWord(word: string, direction: 'es-to-en' | 'en-to-es'): string {
  const lower = word.toLowerCase();
  const dict = direction === 'es-to-en' ? esToEn : enToEs;
  
  if (dict[lower]) {
    const translated = dict[lower];
    if (word[0] === word[0].toUpperCase() && word[0] !== word[0].toLowerCase()) {
      return translated.charAt(0).toUpperCase() + translated.slice(1);
    }
    return translated;
  }
  return word;
}

function translatePhrase(phrase: string, direction: 'es-to-en' | 'en-to-es'): string {
  const dict = direction === 'es-to-en' ? esToEn : enToEs;
  const lower = phrase.toLowerCase().trim();
  
  // Try exact match first
  if (dict[lower]) {
    const translated = dict[lower];
    if (phrase[0] === phrase[0].toUpperCase() && phrase[0] !== phrase[0].toLowerCase()) {
      return translated.charAt(0).toUpperCase() + translated.slice(1);
    }
    return translated;
  }

  // Try phrase without trailing punctuation
  const stripped = lower.replace(/[!¡?¿.,;:]+$/, '');
  const punctMatch = lower.match(/[!¡?¿.,;:]+$/);
  const punct = punctMatch ? punctMatch[0] : '';
  
  if (stripped !== lower && dict[stripped]) {
    const translated = dict[stripped];
    if (phrase[0] === phrase[0].toUpperCase() && phrase[0] !== phrase[0].toLowerCase()) {
      return translated.charAt(0).toUpperCase() + translated.slice(1) + punct;
    }
    return translated + punct;
  }

  // Try translating common multi-word phrases (substring matching)
  const sortedKeys = Object.keys(dict).sort((a, b) => b.length - a.length);
  for (const key of sortedKeys) {
    if (key.includes(' ') && lower.includes(key)) {
      const translated = dict[key];
      const result = lower.replace(key, translated);
      if (phrase[0] === phrase[0].toUpperCase() && phrase[0] !== phrase[0].toLowerCase()) {
        return result.charAt(0).toUpperCase() + result.slice(1);
      }
      return result;
    }
  }

  // Word-by-word fallback
  const words = phrase.split(/(\s+|[!¡?¿.,;:])/);
  let anyTranslated = false;
  const translatedWords = words.map((w) => {
    if (/^\s+$/.test(w) || /^[!¡?¿.,;:]+$/.test(w)) return w;
    const tw = translateWord(w, direction);
    if (tw !== w) anyTranslated = true;
    return tw;
  });
  
  if (anyTranslated) return translatedWords.join('');
  
  // Nothing matched - return original
  return phrase;
}

export type TranslationDirection = 'es-to-en' | 'en-to-es';

export interface TranslationResult {
  original: string;
  translated: string;
  direction: TranslationDirection;
}

export function translateText(text: string, direction: TranslationDirection): TranslationResult {
  return {
    original: text,
    translated: translatePhrase(text, direction),
    direction,
  };
}

export const TRANSLATION_LABELS: Record<TranslationDirection, { label: string; placeholder: string }> = {
  'es-to-en': { label: 'ES → EN', placeholder: 'Escribí en español...' },
  'en-to-es': { label: 'EN → ES', placeholder: 'Type in English...' },
};